import * as React from 'react'


type IHandler = (e: any) => void


type IEvent = 'onKeyDown' | 'onKeyUp' | 'onKeyPress' | 'onMouseDown' | 'onMouseUp' | 'onMouseMove' | 'onClick'



export default class DocumentEventHandler extends React.Component<{
  [e in IEvent]?: IHandler
}, {}> {

  componentDidMount() {
    const { props } = this

    if (props.onKeyDown) {
      on('keydown', props.onKeyDown)
    }

    if (props.onKeyUp) {
      on('keyup', props.onKeyUp)
    }

    if (props.onKeyPress) {
      on('keypress', props.onKeyPress)
    }

    if (props.onMouseUp) {
      on('mouseup', props.onMouseUp)
    }

    if (props.onMouseDown) {
      on('mousedown', props.onMouseDown)
    }

    if (props.onMouseMove) {
      on('mousemove', props.onMouseMove)
    }

    if (props.onClick) {
      on('click', props.onClick)
    }
  }

  componentWillUnmount() {
    const { props } = this

    if (props.onKeyDown) {
      off('keydown', props.onKeyDown)
    }

    if (props.onKeyUp) {
      off('keyup', props.onKeyUp)
    }

    if (props.onKeyPress) {
      off('keypress', props.onKeyPress)
    }

    if (props.onMouseUp) {
      off('mouseup', props.onMouseUp)
    }

    if (props.onMouseDown) {
      off('mousedown', props.onMouseDown)
    }

    if (props.onMouseMove) {
      off('mousemove', props.onMouseMove)
    }

    if (props.onClick) {
      off('click', props.onClick)
    }
  }

  render() {
    return null
  }

}


function on(event, handler) {
  document.addEventListener(event, handler)
}


function off(event, handler) {
  document.removeEventListener(event, handler)
}


// WEBPACK FOOTER //
// ./src/comp/document-event-handler.tsx